export default __webpack_public_path__ + "static/media/logo_las.188d2932.svg";